var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.7656 0.853997C11.9941 0.469165 12.5512 0.469165 12.7796 0.853997L18.5317 10.5426L23.9306 20.1347C24.1754 20.5695 23.8031 21.0928 23.3121 21.0042L12.3774 19.0308C12.3081 19.0183 12.2372 19.0183 12.1679 19.0308L1.23319 21.0042C0.742185 21.0928 0.369919 20.5695 0.614645 20.1347L6.01359 10.5426L11.7656 0.853997Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "changeFill",
    opacity: 0.8,
    d: "M12.4151 6.36039C12.3581 6.24018 12.1871 6.24018 12.1302 6.36039L7.33183 16.4938C7.27205 16.62 7.39388 16.7559 7.52586 16.7102L12.221 15.0837C12.2544 15.0721 12.2908 15.0721 12.3242 15.0837L17.0194 16.7102C17.1513 16.7559 17.2732 16.62 17.2134 16.4938L12.4151 6.36039Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M22.6348 13.2617L24.9996 17.4214",
    stroke: "",
    strokeWidth: 0.589631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M8.43359 1.7793L3.2837 10.4543",
    stroke: "",
    strokeWidth: 0.589631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier1Icon);
export default __webpack_public_path__ + "static/media/tier-1-icon.f25d77ba83a7579c8c01bd1efcc2693d.svg";
export { ForwardRef as ReactComponent };